webpackJsonp([316],{

/***/ 1314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersAccountDetail_vue__ = __webpack_require__(3085);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54e37396_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersAccountDetail_vue__ = __webpack_require__(5785);
function injectStyle (ssrContext) {
  __webpack_require__(5783)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54e37396"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersAccountDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54e37396_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersAccountDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3085:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      id: this.$route.query.userid || 0,
      detailData: {
        creditcardno: null,
        bankcity: null,
        bankname: null,
        photopath: null,
        idnum: null,
        idcardphotopath: null,
        idcardphoto_back: null,
        points: 0,
        frozenpoints: 0,
        spendpoints: 0,
        balance: 0,
        frozenbalance: 0,
        totalwithdraw: 0,
        money_message: 4,
        point_message: 3,
        zfb_account: null,
        idnumverified: 0,
        idnum_verify_photo: null,
        workcard_photo: null
      },
      table: [{
        key: 'creditcardno',
        label: '银行卡号'
      }, {
        key: 'bankname',
        label: '银行信息'
      }, {
        key: 'bankcity',
        label: '开户城市'
      }, {
        key: 'photopath',
        label: '银行卡照片'
      }, {
        key: 'zfb_account',
        label: '支付宝账号'
      }, {
        key: 'idnumverified',
        label: '身份验证状态'
      }, {
        key: 'idnum_verify_photo',
        label: '人脸验证照片'
      }, {
        key: 'idnum',
        label: '身份证号'
      }, {
        key: 'idcardphotopath',
        label: '身份证照片'
      }, {
        key: 'idcardphoto_back',
        label: '身份证背面照片'
      }, {
        key: 'money_message',
        label: '赏金信息'
      }, {
        key: 'point_message',
        label: '零豆信息'
      }],
      imgFields: ['idcardphotopath', 'photopath', 'idcardphoto_back', 'idnum_verify_photo']
    };
  },

  computed: Vuex.mapState({
    options: function options(state) {
      return state.users.options;
    }
  }),
  watch: {},
  created: function created() {
    if (this.id) {
      this.setFormData(this.id);
    }
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    ifKey: function ifKey(scope, name) {
      return scope.row.key === name;
    },
    setFormData: function setFormData(id) {
      var _this = this;

      request.page('getUserAccount', id).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.detailData, data);
      });
    },
    filterImgUrl: function filterImgUrl(url) {
      var suffix = '';
      if (url.indexOf('?x-oss-process') === -1) {
        suffix = '?x-oss-process=image/resize,w_200/auto-orient,1';
      }
      return filter.ossHost(url, suffix);
    }
  })
});

/***/ }),

/***/ 5783:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5784);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("700e0e57", content, true, {});

/***/ }),

/***/ 5784:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UsersAccountDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5785:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-row',{staticClass:"sj-container"},[_c('el-table',{attrs:{"highlight-current-row":true,"data":_vm.table,"show-header":false,"border":""}},[_c('el-table-column',{attrs:{"width":"150","prop":"label"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.label))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.detailData[scope.row.key] || _vm.detailData[scope.row.key] === 0)?_c('span',[(_vm.detailData[scope.row.key].constructor === String && !_vm.imgFields.includes(scope.row.key))?_c('span',[_vm._v(_vm._s(_vm.detailData[scope.row.key]))]):_vm._e(),_vm._v(" "),(_vm.imgFields.includes(scope.row.key))?_c('span',[_c('el-image',{staticStyle:{"width":"200px"},attrs:{"src":_vm.detailData[scope.row.key],"preview-src-list":[_vm.detailData[scope.row.key]]}})],1):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'idnumverified'))?_c('span',_vm._l((_vm.options[scope.row.key]),function(value){return _c('span',[(value.value === _vm.detailData[scope.row.key])?_c('span',{style:({color: value.color})},[_vm._v(_vm._s(value.label))]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'money_message'))?_c('span',[_c('div',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v("已提现赏金: "+_vm._s(_vm.detailData.totalwithdraw))]),_vm._v(" "),_c('div',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v("提现中赏金: "+_vm._s(_vm.detailData.frozenbalance))]),_vm._v(" "),_c('div',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v("赏金金额: "+_vm._s(_vm.detailData.balance))])]):_vm._e(),_vm._v(" "),(_vm.ifKey(scope, 'point_message'))?_c('span',[_c('div',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v("零豆余额: "+_vm._s(_vm.detailData.points))]),_vm._v(" "),_c('div',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v("已使用零豆: "+_vm._s(_vm.detailData.spendpoints))])]):_vm._e()]):_vm._e()]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/users-account.6af075c14c1ec0b9cf49.js